import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import {
  urlGetXmlAssociationJob,
  urlGetXmlDeliveries,
  urlPostXmlDeliveriesAssociation,
} from '../../routes/deliveries.routes'
import { formatJsDateToLocale } from '../../../util/date.service'

const XmlDeliveryHttp = {
  async getXmlDeliveries(tpId, cycleId, dataInicial, dataFinal) {
    try {
      dataInicial.setMilliseconds(0)
      dataFinal.setMilliseconds(0)
      const dtInicial = formatJsDateToLocale(dataInicial).toISO({ suppressMilliseconds: true })
      const dtFinal = formatJsDateToLocale(dataFinal).toISO({ suppressMilliseconds: true })

      const { data } = await authHttp().get(urlGetXmlDeliveries(tpId, cycleId, dtInicial, dtFinal))
      return data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async associateXmlDeliveries(cycleId, tpId, xmlDeliveryIds) {
    try {
      const { data } = await authHttp().post(
        urlPostXmlDeliveriesAssociation(cycleId),
        {
          tp_id: tpId,
          xml_delivery_ids: xmlDeliveryIds,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      return data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getXmlAssociationJob(jobId) {
    try {
      const { data } = await authHttp().get(urlGetXmlAssociationJob(jobId), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default XmlDeliveryHttp
